(function () {
  'use strict';
  var script = document.currentScript;
  var API = ((script && script.dataset.api) || 'https://internal.skysimworld.de').replace(/\/$/, '');
  var PULS_MS = 15000;
  var TIMEOUT_MS = 30 * 60 * 1000;
  var PAKET_MAX = 60 * 1024;
  var SCHRITTE = ['tag', 'zeit', 'bestaetigt', 'personen', 'extras', 'zusammenfassung', 'warenkorb', 'fehler', 'schliessen', 'hinweis', 'newsletter'];
  var FE_SCHRITT = /^fe-[a-z-]{1,17}$/;
  var KLICKBAR = 'a, button, [role="button"], input, select, textarea, summary, label, video, [onclick]';
  var laeuft = false, hoererDa = false;
  var puffer = [];
  var timer = null, pulsTimer = null;
  var besucher = '', sitzung = '', aufrufId = '';
  var folgeOffen = false;
  var seiteNr = 1, maxScroll = 0;
  var sichtbarSeit = null, sichtbarMs = 0;
  var endeGeschickt = false, letztesEnde = 0;
  var tabWechsel = 0, auswahlAnz = 0, wahlGeschickt = 0, videoGeschickt = 0, dialogAnz = 0;
  var startZeit = Date.now(), ersteAktionMs = 0;
  var sektionen = new Map();
  var bilder = new Map();
  var felder = new Map();
  var zoegern = new Map();
  var klickfolge = [];
  var offeneKlicks = [];
  var letzterKlick = { el: null, z: 0 };
  var hoverSektion = null;
  var zuletzt = { sek: '', bild: '', feld: '', zoeg: '' };

  function zufall() {
    var b = new Uint8Array(8);
    (window.crypto && crypto.getRandomValues) ? crypto.getRandomValues(b)
      : b.forEach(function (_, i) { b[i] = Math.floor(Math.random() * 256); });
    var s = '';
    for (var i = 0; i < b.length; i++) s += (b[i] + 256).toString(16).slice(1);
    return s;
  }
  function istBot() {
    try {
      if (navigator.webdriver) return true;
      var ua = String(navigator.userAgent || '').toLowerCase();
      return /\b(bot|crawl|spider|slurp|headless|phantom|scrapy|python|curl|wget|lighthouse)\b/.test(ua);
    } catch (e) { return false; }
  }
  function erlaubt() {
    if (istBot()) return false;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }
  function geraet() {
    var w = window.innerWidth || 0;
    return w <= 700 ? 'handy' : (w <= 1024 ? 'tablet' : 'desktop');
  }
  function herkunft() {
    try {
      var q = new URLSearchParams(location.search || '');
      var sauber = function (x) { return String(x || '').toLowerCase().replace(/[^a-z0-9.\-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 30); };
      if (q.get('utm_source')) {
        if (sauber(q.get('utm_source')) === 'google' && /^(cpc|ppc|paid)$/.test(sauber(q.get('utm_medium')))) {
          return ('utm:google:anzeige' + (q.get('utm_campaign') ? ':' + sauber(q.get('utm_campaign')) : '')).slice(0, 100);
        }
        var teile = ['utm', sauber(q.get('utm_source'))];
        if (q.get('utm_medium')) teile.push(sauber(q.get('utm_medium')));
        if (q.get('utm_campaign')) teile.push(sauber(q.get('utm_campaign')));
        return teile.join(':').slice(0, 100);
      }
      if (q.get('gclid')) return 'utm:google:anzeige';
      if (!document.referrer) return '';
      var u = new URL(document.referrer);
      return u.host === location.host ? '' : u.host.replace(/^www\./, '').toLowerCase();
    } catch (e) { return ''; }
  }
  function txt(s, max) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, max); }
  function ersteAktion() { if (!ersteAktionMs) ersteAktionMs = Date.now() - startZeit; }
  function dauerJetzt() {
    var ms = sichtbarMs;
    if (sichtbarSeit != null) ms += Date.now() - sichtbarSeit;
    return Math.round(ms);
  }
  function scrollJetzt() {
    var doc = document.documentElement;
    var hoehe = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
    if (hoehe <= 0) return 0;
    var unten = (window.scrollY || doc.scrollTop || 0) + window.innerHeight;
    return Math.max(0, Math.min(100, Math.round(unten * 100 / hoehe)));
  }
  function zeitMerken(ts) { try { sessionStorage.setItem('ssw_last', String(ts || Date.now())); } catch (e) {} }
  function sitzungAbgelaufen(jetzt) {
    try {
      var last = parseInt(sessionStorage.getItem('ssw_last') || '', 10);
      return !!last && (jetzt - last) > TIMEOUT_MS;
    } catch (e) { return false; }
  }
  var letzteAktivitaet = 0;
  function aktivitaet() {
    var jetzt = Date.now();
    if (jetzt - letzteAktivitaet < 1000) return;
    letzteAktivitaet = jetzt;
    if (!laeuft) return;
    if (sitzungAbgelaufen(jetzt)) sitzungNeu(jetzt);
    zeitMerken(jetzt);
  }

  function paketBauen(teil, folge) {
    var zone = '';
    try { zone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    var p = {
      b: besucher, s: sitzung, g: geraet(), w: window.innerWidth || 0, r: herkunft(),
      sp: txt(navigator.language, 10), dp: Math.round((window.devicePixelRatio || 1) * 100) / 100,
      to: ('ontouchstart' in window) ? 1 : 0, tz: txt(zone, 40), e: teil,
    };
    if (folge) p.folge = 1;
    return JSON.stringify(p);
  }
  function bytes(s) { try { return new Blob([s]).size; } catch (e) { return s.length * 2; } }
  function senden(beacon) {
    if (!laeuft || !puffer.length) return;
    var runden = 0;
    while (puffer.length && runden++ < 200) {
      var n = Math.min(50, puffer.length);
      var paket = paketBauen(puffer.slice(0, n), folgeOffen);
      while (n > 1 && bytes(paket) > PAKET_MAX) {
        n = Math.ceil(n / 2);
        paket = paketBauen(puffer.slice(0, n), folgeOffen);
      }
      puffer.splice(0, n);
      folgeOffen = false;
      try {
        if (beacon && navigator.sendBeacon) {
          navigator.sendBeacon(API + '/api/track', new Blob([paket], { type: 'text/plain' }));
        } else {
          fetch(API + '/api/track', { method: 'POST', body: paket, headers: { 'Content-Type': 'text/plain' }, keepalive: true }).catch(function () {});
        }
      } catch (e) { break; }
    }
  }
  function merken(e) {
    if (!laeuft) return;
    if (e.ts == null) e.ts = Date.now();
    puffer.push(e);
    if (puffer.length >= 40) senden(false);
  }

  function sektionsName(el) {
    var h = el.querySelector('h1, h2, h3, .ssw-kicker');
    var name = h ? txt(h.textContent, 60) : '';
    if (!name) {
      var innen = el.querySelector('section[class], div[class]');
      var kl = innen ? String(innen.className).match(/ssw-[a-z0-9\-]+/) : null;
      name = kl ? kl[0] : '';
    }
    if (!name) name = txt((el.id || '').replace(/^shopify-section-/, '').split('__').pop(), 40) || 'Abschnitt';
    return name;
  }
  function sektionVon(el) {
    var w = el && el.closest ? el.closest('.shopify-section') : null;
    return w ? txt((w.id || '').replace(/^shopify-section-/, ''), 60) : '';
  }
  function sektionenAufbauen() {
    var alle = document.querySelectorAll('.shopify-section');
    if (!alle.length) alle = document.querySelectorAll('main section, main > div');
    var nr = 0;
    alle.forEach(function (el) {
      if (nr >= 30) return;
      var id = txt((el.id || 'abschnitt-' + nr).replace(/^shopify-section-/, ''), 60);
      if (sektionen.has(id)) return;
      nr++;
      sektionen.set(id, {
        el: el, label: sektionsName(el), top: nr, ms: 0, seit: null, da: false,
        anteil: 0, hover: 0, hoverSeit: null, klicks: 0,
      });
    });
  }
  function sektionSichtbarkeit() {
    var beob = new IntersectionObserver(function (eintraege) {
      var jetzt = Date.now();
      eintraege.forEach(function (e) {
        var s = null;
        sektionen.forEach(function (v) { if (v.el === e.target) s = v; });
        if (!s) return;
        var hoehe = e.boundingClientRect.height || 1;
        var anteil = Math.round(e.intersectionRect.height * 100 / hoehe);
        if (anteil > s.anteil) s.anteil = anteil;
        var da = e.isIntersecting && (anteil >= 50 || e.intersectionRect.height >= (window.innerHeight || 1) * 0.5);
        s.da = da;
        if (da && s.seit == null && sichtbarSeit != null) s.seit = jetzt;
        if (!da && s.seit != null) { s.ms += jetzt - s.seit; s.seit = null; }
      });
    }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
    sektionen.forEach(function (s) { beob.observe(s.el); });
  }
  function sektionenListe() {
    var jetzt = Date.now();
    var liste = [];
    sektionen.forEach(function (s, id) {
      var ms = s.ms + (s.seit != null ? jetzt - s.seit : 0);
      var hover = s.hover + (s.hoverSeit != null ? jetzt - s.hoverSeit : 0);
      liste.push({ id: id, label: s.label, top: s.top, ms: Math.round(ms), anteil: s.anteil, hover: Math.round(hover), klicks: s.klicks });
    });
    return liste.slice(0, 30);
  }

  function bilderAufbauen() {
    var alle = document.querySelectorAll('img');
    var n = 0;
    var beob = new IntersectionObserver(function (eintraege) {
      var jetzt = Date.now();
      eintraege.forEach(function (e) {
        var b = bilder.get(e.target.__sswKey);
        if (!b) return;
        b.da = !!(e.isIntersecting && e.intersectionRatio >= 0.5);
        if (b.da && b.seit == null && sichtbarSeit != null) b.seit = jetzt;
        if (!b.da && b.seit != null) { b.ms += jetzt - b.seit; b.seit = null; }
      });
    }, { threshold: [0, 0.5] });
    alle.forEach(function (img) {
      if (n >= 40) return;
      var r = img.getBoundingClientRect();
      if ((r.width || img.naturalWidth || 0) < 80 || (r.height || img.naturalHeight || 0) < 60) return;
      var src = img.currentSrc || img.src || '';
      if (!src) return;
      var datei;
      if (src.slice(0, 5) === 'data:') {
        datei = txt(img.alt, 80) || 'eingebettetes-bild';
      } else {
        datei = txt(src.split('?')[0].split('/').pop(), 80);
      }
      if (!datei) return;
      n++;
      var key = datei + '|' + n;
      img.__sswKey = key;
      bilder.set(key, { datei: datei, alt: txt(img.alt, 80), sektion: sektionVon(img), ms: 0, seit: null, da: false });
      beob.observe(img);
    });
  }
  function bilderListe() {
    var jetzt = Date.now();
    var liste = [];
    bilder.forEach(function (b) {
      var ms = b.ms + (b.seit != null ? jetzt - b.seit : 0);
      if (ms >= 300) liste.push({ datei: b.datei, alt: b.alt, sektion: b.sektion, ms: Math.round(ms) });
    });
    liste.sort(function (a, b) { return b.ms - a.ms; });
    return liste.slice(0, 40);
  }

  function hoverAn() {
    document.addEventListener('mouseover', function (ev) {
      var jetzt = Date.now();
      var w = ev.target && ev.target.closest ? ev.target.closest('.shopify-section') : null;
      var s = null;
      if (w) sektionen.forEach(function (v) { if (v.el === w) s = v; });
      if (hoverSektion && hoverSektion !== s && hoverSektion.hoverSeit != null) {
        hoverSektion.hover += jetzt - hoverSektion.hoverSeit;
        hoverSektion.hoverSeit = null;
      }
      if (s && s.hoverSeit == null) s.hoverSeit = jetzt;
      hoverSektion = s;

      var ziel = ev.target.closest && ev.target.closest('a, button, [role="button"], input[type="submit"], summary');
      if (ziel) {
        var key = ziel.__sswZoeg || (ziel.__sswZoeg = 'z' + Math.random().toString(16).slice(2, 8));
        var z = zoegern.get(key);
        if (!z) { z = { ziel: klickZiel(ziel), hover: 0, seit: null, geklickt: false }; zoegern.set(key, z); }
        if (z.seit == null) z.seit = jetzt;
      }
    }, true);
    document.addEventListener('mouseout', function (ev) {
      var ziel = ev.target.closest && ev.target.closest('a, button, [role="button"], input[type="submit"], summary');
      if (ziel && ziel.__sswZoeg) {
        var z = zoegern.get(ziel.__sswZoeg);
        if (z && z.seit != null) { z.hover += Date.now() - z.seit; z.seit = null; }
      }
    }, true);
  }
  function zoegernListe() {
    var jetzt = Date.now();
    var liste = [];
    zoegern.forEach(function (z) {
      var hover = z.hover + (z.seit != null ? jetzt - z.seit : 0);
      if (!z.geklickt && hover >= 600) liste.push({ ziel: z.ziel, ms: Math.round(hover) });
    });
    liste.sort(function (a, b) { return b.ms - a.ms; });
    return liste.slice(0, 20);
  }

  function textOhneCode(el) {
    var t = '';
    for (var k = el.firstChild; k && t.length < 400; k = k.nextSibling) {
      if (k.nodeType === 3) t += k.nodeValue;
      else if (k.nodeType === 1 && !/^(style|script|noscript|template)$/i.test(k.tagName)) t += ' ' + textOhneCode(k);
    }
    return t;
  }
  function sichtText(el, max) {
    var t = '';
    try { t = typeof el.innerText === 'string' ? el.innerText : ''; } catch (e) { t = ''; }
    if (!t) try { t = textOhneCode(el); } catch (e2) { t = ''; }
    return txt(t, max);
  }
  function feldLabel(el) {
    var t = '';
    try {
      var by = el.getAttribute('aria-labelledby');
      if (by) by.split(/\s+/).forEach(function (id) { var l = document.getElementById(id); if (l) t += ' ' + sichtText(l, 60); });
      t = txt(t, 60);
      if (!t && el.labels && el.labels.length) t = sichtText(el.labels[0], 60);
      if (!t && el.closest) { var l2 = el.closest('label'); if (l2) t = sichtText(l2, 60); }
      if (!t) t = txt(el.getAttribute('placeholder'), 60);
      if (!t && /^(submit|button|reset)$/i.test(el.type || '')) t = txt(el.value, 60);
      if (!t) t = txt(el.getAttribute('title'), 60);
      if (!t) t = txt(el.name || el.id, 60);
    } catch (e) {}
    if (!t) return '';
    var art = el.tagName.toLowerCase() === 'input' ? String(el.type || 'text').toLowerCase() : el.tagName.toLowerCase();
    return t + ' [' + art + ']';
  }
  function klickZiel(el) {
    var tag = el.tagName ? el.tagName.toLowerCase() : '';
    var t = txt(el.getAttribute && el.getAttribute('aria-label'), 100);
    if (!t && /^(input|textarea|select)$/.test(tag)) t = feldLabel(el);
    if (!t && tag === 'video') t = 'Video: ' + (txt(String(el.currentSrc || el.src || '').split('?')[0].split('/').pop(), 80) || 'ohne Namen');
    if (!t) t = sichtText(el, 100);
    if (!t) {
      var img = el.querySelector && el.querySelector('img[alt]');
      t = img ? txt(img.getAttribute('alt'), 100) : '';
    }
    if (!t && el.getAttribute) t = txt(el.getAttribute('title'), 100);
    if (!t) t = '<' + tag + (el.id ? '#' + el.id : '') + '>';
    return txt(t, 100);
  }
  function zielUrl(el) {
    var href = typeof el.href === 'string' ? el.href : (el.getAttribute ? el.getAttribute('href') : '');
    if (!href) return '';
    try {
      var u = new URL(String(href), location.href);
      var p = u.protocol;
      if (p === 'tel:' || p === 'sms:' || p === 'mailto:') return p;
      if (p === 'whatsapp:' || /^(www\.)?(wa\.me|api\.whatsapp\.com|whatsapp\.com)$/i.test(u.host)) return 'https://wa.me/';
      if (p !== 'http:' && p !== 'https:') return '';
      return u.host === location.host ? u.pathname : u.href.slice(0, 200);
    } catch (e) { return ''; }
  }
  function selektor(el) {
    var s = el.tagName.toLowerCase();
    if (el.id) return txt(s + '#' + el.id, 80);
    var kl = String(el.className || '').trim().split(/\s+/).slice(0, 2).join('.');
    return txt(kl ? s + '.' + kl : s, 80);
  }
  function zustand(el) {
    var p = el.parentElement;
    var werte = '';
    if (p && p.querySelectorAll) {
      var zahlen = p.querySelectorAll('input[type="number"]');
      for (var i = 0; i < zahlen.length && i < 5; i++) werte += '|' + zahlen[i].value;
    }
    return [
      el.disabled ? 1 : 0, el.hidden ? 1 : 0, String(el.className || ''),
      el.getAttribute('aria-pressed') || '', el.getAttribute('aria-expanded') || '', el.getAttribute('aria-selected') || '',
      txt(el.textContent, 200),
      p ? String(p.className || '') + '|' + txt(p.textContent, 300) + werte : '',
    ].join('|');
  }
  function klickEntscheiden(offen, vorzeitig) {
    var i = offeneKlicks.indexOf(offen);
    if (i < 0) return;
    offeneKlicks.splice(i, 1);
    clearTimeout(offen.timer);
    var gleich = false;
    if (!vorzeitig) {
      try { gleich = document.contains(offen.el) && location.href === offen.url && zustand(offen.el) === offen.vorher; } catch (e) {}
    }
    offen.e.art = gleich ? 'wut' : 'ok';
    merken(offen.e);
  }
  function klicksAufloesen() { while (offeneKlicks.length) klickEntscheiden(offeneKlicks[0], true); }
  function klickAn() {
    document.addEventListener('click', function (ev) {
      try {
        ersteAktion();
        var jetzt = Date.now();
        var ziel0 = ev.target && ev.target.nodeType === 1 ? ev.target : (ev.target ? ev.target.parentElement : null);
        if (!ziel0 || !ziel0.closest || !ziel0.tagName) return;
        if (/^(html|body)$/i.test(ziel0.tagName)) return;
        var interaktiv = ziel0.closest(KLICKBAR);
        var el = interaktiv || ziel0;
        if (interaktiv && /^(input|select|textarea)$/i.test(interaktiv.tagName) && letzterKlick.el && letzterKlick.el.tagName === 'LABEL'
            && jetzt - letzterKlick.z < 100 && letzterKlick.el.contains(interaktiv)) return;
        letzterKlick = { el: el, z: jetzt };
        if (interaktiv && interaktiv.__sswZoeg) {
          var z = zoegern.get(interaktiv.__sswZoeg);
          if (z) z.geklickt = true;
        }
        var art = 'ok';
        if (!interaktiv) {
          var zeiger = '';
          try { zeiger = getComputedStyle(ziel0).cursor; } catch (e4) {}
          if (zeiger !== 'pointer') art = 'tot';
        }
        if (art === 'tot' && !sichtText(ziel0, 5)) return;
        klickfolge.push({ x: ev.clientX, y: ev.clientY, z: jetzt });
        if (klickfolge.length > 4) klickfolge.shift();
        var schnell = klickfolge.length >= 3 && klickfolge.slice(-3).every(function (k) {
          return jetzt - k.z <= 800 && Math.abs(k.x - ev.clientX) <= 30 && Math.abs(k.y - ev.clientY) <= 30;
        });
        var sektionId = sektionVon(el);
        sektionen.forEach(function (v, k) { if (k === sektionId) v.klicks++; });
        var e = {
          t: 'klick', pfad: location.pathname, ziel: klickZiel(el), url: zielUrl(el),
          x: Math.round((ev.clientX || 0) * 100 / (window.innerWidth || 1)),
          y: Math.round((ev.clientY || 0) * 100 / (window.innerHeight || 1)),
          sek: sektionId, sel: selektor(el), art: art, ts: jetzt,
        };
        var kasse = el.closest ? el.closest('[data-ssw-checkout]') : null;
        var textfeld = /^(textarea|select)$/i.test(el.tagName)
          || (/^input$/i.test(el.tagName) && /^(text|search|email|tel|url|password|)$/i.test(el.getAttribute('type') || ''));
        if (schnell && !kasse && !textfeld) {
          var offen = { e: e, el: el, vorher: zustand(el), url: location.href, timer: null };
          offen.timer = setTimeout(function () { klickEntscheiden(offen, false); }, 250);
          offeneKlicks.push(offen);
        } else {
          merken(e);
          if (kasse) senden(true);
        }
      } catch (e3) { }
    }, true);
  }

  function feldName(el) {
    return txt(el.name || el.id || el.placeholder || el.type || el.tagName, 60);
  }
  function felderAn() {
    document.addEventListener('focusin', function (ev) {
      var el = ev.target;
      if (!el || !/^(input|textarea|select)$/i.test(el.tagName)) return;
      if (/^(password|hidden)$/i.test(el.type || '')) return;
      ersteAktion();
      var key = feldName(el);
      var f = felder.get(key);
      if (!f) {
        var form = el.closest ? el.closest('form') : null;
        f = { feld: key, formular: form ? txt((form.getAttribute('action') || form.id || 'formular'), 60) : '', ms: 0, seit: null, tasten: 0, abgeschickt: false, pausiert: false };
        felder.set(key, f);
      }
      f.seit = Date.now();
      f.pausiert = false;
      el.__sswFeld = key;
    }, true);
    document.addEventListener('focusout', function (ev) {
      var el = ev.target;
      if (!el || !el.__sswFeld) return;
      var f = felder.get(el.__sswFeld);
      if (f && f.seit != null) { f.ms += Date.now() - f.seit; f.seit = null; }
      if (f) f.pausiert = false;
    }, true);
    document.addEventListener('input', function (ev) {
      var el = ev.target;
      if (el && el.__sswFeld) {
        var f = felder.get(el.__sswFeld);
        if (f) f.tasten++;
      }
    }, true);
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.querySelectorAll) return;
      form.querySelectorAll('input, textarea, select').forEach(function (el) {
        if (el.__sswFeld) { var f = felder.get(el.__sswFeld); if (f) f.abgeschickt = true; }
      });
      try {
        var schritt = txt(form.getAttribute && form.getAttribute('data-ssw-schritt'), 20).toLowerCase();
        if (schritt === 'newsletter' && dialogAnz < 300) {
          dialogAnz++;
          ersteAktion();
          merken({ t: 'dialog', p: location.pathname, schritt: schritt, wert: '', ts: Date.now() });
        }
      } catch (e4) { }
    }, true);
  }
  function felderListe() {
    var jetzt = Date.now();
    var liste = [];
    felder.forEach(function (f) {
      var ms = f.ms + (f.seit != null ? jetzt - f.seit : 0);
      if (ms >= 200) liste.push({ feld: f.feld, formular: f.formular, ms: Math.round(ms), tasten: Math.min(9999, f.tasten), fertig: f.abgeschickt ? 1 : 0 });
    });
    return liste.slice(0, 20);
  }

  function auswahlAn() {
    document.addEventListener('mouseup', function () {
      try {
        var sel = window.getSelection && window.getSelection();
        if (!sel || sel.isCollapsed) return;
        var t = txt(sel.toString(), 120);
        if (t.length < 4 || wahlGeschickt >= 20) return;
        var knoten = sel.anchorNode;
        var el = knoten && knoten.nodeType === 1 ? knoten : (knoten ? knoten.parentElement : null);
        if (el && el.closest && el.closest('input, textarea')) return;
        wahlGeschickt++; auswahlAnz++;
        merken({ t: 'wahl', pfad: location.pathname, text: t, sek: sektionVon(el) });
      } catch (e) {}
    });
  }

  function videosAn() {
    ['play', 'pause', 'ended'].forEach(function (was) {
      document.addEventListener(was, function (ev) {
        var v = ev.target;
        if (!v || v.tagName !== 'VIDEO' || videoGeschickt >= 40) return;
        videoGeschickt++;
        var datei = txt((v.currentSrc || v.src || 'video').split('?')[0].split('/').pop(), 80);
        merken({ t: 'video', pfad: location.pathname, datei: datei, was: was, sekunde: Math.round(v.currentTime || 0), sek: sektionVon(v) });
      }, true);
    });
  }

  function dialogAn() {
    document.addEventListener('ssw:dialog', function (ev) {
      try {
        var d = (ev && ev.detail) || {};
        var schritt = txt(d.schritt, 20).toLowerCase();
        if ((SCHRITTE.indexOf(schritt) < 0 && !FE_SCHRITT.test(schritt)) || dialogAnz >= 300) return;
        dialogAnz++;
        ersteAktion();
        merken({ t: 'dialog', p: location.pathname, schritt: schritt, wert: txt(d.wert, 60), ts: Date.now() });
      } catch (e) {}
    });
  }

  function warenkorbVerknuepfen() {
    if (!laeuft || !/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?$/i.test(location.pathname)) return;
    try {
      if (sessionStorage.getItem('ssw_cart') === sitzung) return;
      sessionStorage.setItem('ssw_cart', sitzung);
    } catch (e) { return; }
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      sag('Warenkorb bekommt Sitzungs-Id ' + sitzung);
      fetch(String(root).replace(/\/$/, '') + '/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { ssw_sid: sitzung, ssw_bid: besucher } }),
      }).catch(function () {});
    } catch (e) {}
  }

  function pausieren(jetzt) {
    sektionen.forEach(function (s) {
      if (s.seit != null) { s.ms += jetzt - s.seit; s.seit = null; }
      if (s.hoverSeit != null) { s.hover += jetzt - s.hoverSeit; s.hoverSeit = null; }
    });
    hoverSektion = null;
    bilder.forEach(function (b) { if (b.seit != null) { b.ms += jetzt - b.seit; b.seit = null; } });
    zoegern.forEach(function (z) { if (z.seit != null) { z.hover += jetzt - z.seit; z.seit = null; } });
    felder.forEach(function (f) { if (f.seit != null) { f.ms += jetzt - f.seit; f.seit = null; f.pausiert = true; } });
  }
  function fortsetzen(jetzt) {
    sektionen.forEach(function (s) { if (s.da && s.seit == null) s.seit = jetzt; });
    bilder.forEach(function (b) { if (b.da && b.seit == null) b.seit = jetzt; });
    felder.forEach(function (f) {
      if (!f.pausiert) return;
      f.pausiert = false;
      var a = document.activeElement;
      if (a && a.__sswFeld === f.feld) f.seit = jetzt;
    });
  }

  function listeSenden(typ, liste, extra) {
    if (!liste.length) return;
    var key = JSON.stringify(liste);
    if (key === zuletzt[typ]) return;
    zuletzt[typ] = key;
    var e = { t: typ, pfad: location.pathname, liste: liste };
    if (extra) for (var k in extra) e[k] = extra[k];
    merken(e);
  }
  function abschliessen(beacon) {
    klicksAufloesen();
    listeSenden('sek', sektionenListe(), { id: aufrufId });
    listeSenden('bild', bilderListe());
    listeSenden('feld', felderListe());
    listeSenden('zoeg', zoegernListe());
    var lade = 0;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) lade = Math.round(nav.domContentLoadedEventEnd || 0);
    } catch (e) {}
    merken({
      t: 'ende', id: aufrufId, dauer: dauerJetzt(), scroll: Math.max(maxScroll, scrollJetzt()),
      lade: lade, aktion: ersteAktionMs, tabs: tabWechsel, wahl: auswahlAnz,
    });
    letztesEnde = Date.now();
    senden(beacon);
  }

  function aufrufNeu(jetzt) {
    aufrufId = zufall();
    startZeit = jetzt; ersteAktionMs = 0; sichtbarMs = 0; sichtbarSeit = null;
    maxScroll = scrollJetzt(); tabWechsel = 0; auswahlAnz = 0; wahlGeschickt = 0; videoGeschickt = 0; dialogAnz = 0;
    endeGeschickt = false; letztesEnde = 0;
    sektionen.forEach(function (s) { s.ms = 0; s.hover = 0; s.klicks = 0; s.seit = null; s.hoverSeit = null; });
    bilder.forEach(function (b) { b.ms = 0; b.seit = null; });
    felder.clear(); zoegern.clear(); klickfolge.length = 0;
    offeneKlicks.forEach(function (o) { clearTimeout(o.timer); }); offeneKlicks.length = 0;
    hoverSektion = null;
    zuletzt = { sek: '', bild: '', feld: '', zoeg: '' };
    merken({ t: 'seite', id: aufrufId, nr: seiteNr, pfad: location.pathname, titel: txt(document.title, 120) });
    zeitMerken(jetzt);
    senden(false);
    warenkorbVerknuepfen();
  }
  function sitzungNeu(jetzt) {
    sag('Sitzung nach Pause > 30 min neu begonnen');
    sitzung = zufall();
    seiteNr = 1;
    try { sessionStorage.setItem('ssw_sid', sitzung); sessionStorage.setItem('ssw_nr', '1'); } catch (e) {}
    folgeOffen = true;
    aufrufNeu(jetzt);
    if (document.visibilityState === 'visible') { sichtbarSeit = jetzt; fortsetzen(jetzt); }
  }

  function starten() {
    if (laeuft) return;
    laeuft = true;
    var jetzt = Date.now();
    var folge = false;
    try {
      besucher = localStorage.getItem('ssw_bid') || '';
      if (!/^[a-z0-9]{8,32}$/.test(besucher)) { besucher = zufall(); localStorage.setItem('ssw_bid', besucher); }
      sitzung = sessionStorage.getItem('ssw_sid') || '';
      if (/^[a-z0-9]{8,32}$/.test(sitzung) && sitzungAbgelaufen(jetzt)) { sitzung = ''; folge = true; }
      if (!/^[a-z0-9]{8,32}$/.test(sitzung)) {
        sitzung = zufall();
        sessionStorage.setItem('ssw_sid', sitzung);
        sessionStorage.setItem('ssw_nr', '0');
      }
      seiteNr = (parseInt(sessionStorage.getItem('ssw_nr') || '0', 10) || 0) + 1;
      sessionStorage.setItem('ssw_nr', String(seiteNr));
    } catch (e) {
      besucher = besucher || zufall();
      sitzung = sitzung || zufall();
    }
    folgeOffen = folge;
    if (folge) sag('Wiederkehr im Tab nach > 30 min: neue Sitzung');
    aufrufNeu(jetzt);
    sichtbarSeit = document.visibilityState === 'visible' ? jetzt : null;

    if (!hoererDa) {
      hoererDa = true;
      sektionenAufbauen();
      sektionSichtbarkeit();
      bilderAufbauen();
      hoverAn();
      klickAn();
      felderAn();
      auswahlAn();
      videosAn();
      dialogAn();

      window.addEventListener('scroll', function () {
        ersteAktion();
        var s = scrollJetzt();
        if (s > maxScroll) maxScroll = s;
      }, { passive: true });
      ['pointerdown', 'keydown', 'mousemove', 'touchstart', 'focusin', 'input'].forEach(function (was) {
        document.addEventListener(was, aktivitaet, { passive: true, capture: true });
      });
      window.addEventListener('scroll', aktivitaet, { passive: true });

      document.addEventListener('visibilitychange', function () {
        if (!laeuft) return;
        var jetzt = Date.now();
        if (document.visibilityState === 'hidden') {
          if (sichtbarSeit != null) { sichtbarMs += jetzt - sichtbarSeit; sichtbarSeit = null; }
          pausieren(jetzt);
          if (!endeGeschickt) abschliessen(true);
        } else {
          if (sitzungAbgelaufen(jetzt)) sitzungNeu(jetzt);
          else tabWechsel++;
          if (sichtbarSeit == null) sichtbarSeit = jetzt;
          fortsetzen(jetzt);
        }
      });
      window.addEventListener('pagehide', function () {
        if (!laeuft || endeGeschickt) return;
        endeGeschickt = true;
        if (Date.now() - letztesEnde < 1000) { klicksAufloesen(); senden(true); }
        else abschliessen(true);
      });
      window.addEventListener('pageshow', function (ev) {
        if (ev && ev.persisted) endeGeschickt = false;
      });
    } else {
      fortsetzen(jetzt);
    }
    if (timer) clearInterval(timer);
    timer = setInterval(function () { if (puffer.length) senden(false); }, 8000);
    if (pulsTimer) clearInterval(pulsTimer);
    pulsTimer = setInterval(function () {
      if (document.visibilityState === 'visible' && !endeGeschickt) abschliessen(false);
    }, PULS_MS);
  }

  function stoppen() {
    laeuft = false;
    if (timer) { clearInterval(timer); timer = null; }
    if (pulsTimer) { clearInterval(pulsTimer); pulsTimer = null; }
    offeneKlicks.forEach(function (o) { clearTimeout(o.timer); }); offeneKlicks.length = 0;
    puffer.length = 0;
    try {
      localStorage.removeItem('ssw_bid');
      sessionStorage.removeItem('ssw_sid');
      sessionStorage.removeItem('ssw_nr');
      sessionStorage.removeItem('ssw_last');
      sessionStorage.removeItem('ssw_cart');
    } catch (e) {}
  }

  var DEBUG = /ssw-debug/.test(location.search);
  function sag(text) { if (DEBUG) try { console.log('[ssw-analyse] ' + text); } catch (e) {} }
  function pruefeUndStarte() {
    if (laeuft) return true;
    if (erlaubt()) { sag('Zustimmung da – Erfassung startet'); starten(); return true; }
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    sag(cp ? 'Zustimmungs-API da, aber (noch) keine Zustimmung fuer Analyse' : 'Zustimmungs-API noch nicht geladen');
    return false;
  }
  function apiNachladen() {
    try {
      if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
        sag('lade Zustimmungs-API nach (loadFeatures)');
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) {
          sag(fehler ? 'loadFeatures-Fehler: ' + fehler : 'Zustimmungs-API nachgeladen');
          pruefeUndStarte();
        });
      }
    } catch (e) { sag('loadFeatures nicht verfuegbar'); }
  }
  pruefeUndStarte();
  apiNachladen();
  var versuche = 0;
  var warte = setInterval(function () {
    versuche++;
    if (versuche === 5) apiNachladen();
    if (pruefeUndStarte() || versuche >= 60) clearInterval(warte);
  }, 1000);
  document.addEventListener('visitorConsentCollected', function () {
    sag('Banner-Entscheidung eingegangen');
    if (erlaubt()) starten();
    else if (laeuft) stoppen();
  });
})();
